import { ReactNode } from "react";

export type CardWithHintProps = {
  title: ReactNode;
  description: ReactNode;
  icon: ReactNode;
  hint: ReactNode;
};

export const CardWithHint = ({
  title,
  description,
  icon,
  hint,
}: CardWithHintProps) => {
  return (
    <section className="flex basis-1/2 flex-col gap-6 justify-between py-6 px-5 bg-white rounded-xl border md:py-9 md:px-10">
      <div className="flex flex-col gap-2 items-center md:flex-row">
        {icon}
        <h3 className="flex-1 text-[20px] font-bold md:text-3xl md:leading-[41px]">
          {title}
        </h3>
      </div>
      <p className="text-base text-center md:text-lg md:text-left">
        {description}
      </p>
      <p className="py-2.5 px-9 text-base text-center text-white bg-cornflower-blue rounded-xl md:text-lg md:text-left">
        {hint}
      </p>
    </section>
  );
};
